const countdownTimer = document.getElementById('announcementCountdown');
const announcementMessages = document.getElementById('announcement-bar-announces');
const announcementCountdownMessage = document.getElementById('annoucement-bar-countdown-announce');

if (countdownTimer) {
  let days = countdownTimer.querySelector(".days .num");
  let hours = countdownTimer.querySelector(".hours .num");
  let minutes = countdownTimer.querySelector(".minutes .num");
  let seconds = countdownTimer.querySelector(".seconds .num");
  const countdownDateValue = countdownTimer.dataset.date;
  // Get the selected date and time
  const selectedDate = new Date(countdownDateValue);
  let interval;

  // Update the countdown timer every second
  interval = setInterval(() => {
    const now = new Date();
    const offset = now.getTimezoneOffset() / 60;
    const timeRemaining = selectedDate - now - (offset * 60 * 60 * 1000);

    // Calculate the days, hours, minutes, and seconds remaining
    const daysRemaining = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hoursRemaining = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    const minutesRemaining = Math.floor((timeRemaining / (1000 * 60)) % 60);
    const secondsRemaining = Math.floor((timeRemaining / 1000) % 60);

    // Add leading zero if number is less than 10
    function addLeadingZero(number) {
      if (number < 10) {
        return "0" + number;
      } else {
        return number.toString();
      }
    }

    // Update the countdown timer HTML
    days.textContent = `${daysRemaining}`;
    hours.textContent = `${addLeadingZero(hoursRemaining)}`;
    minutes.textContent = `${addLeadingZero(minutesRemaining)}`;
    seconds.textContent = `${addLeadingZero(secondsRemaining)}`;

    if (Math.floor(timeRemaining / 1000) > 0) {
      announcementMessages.classList.add('hidden');
      announcementCountdownMessage.classList.remove('hidden')
      countdownTimer.classList.remove("visually-hidden");
    } else {
      announcementCountdownMessage.classList.add('hidden')
      announcementMessages.classList.remove('hidden');
      announcementCountdown.classList.add('hidden');
      clearInterval(interval);
    }
  }, 1000);
}